///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspotitem = abcsetup.thoughtspotitem || {};
abcsetup.thoughtspotitem.edit = abcsetup.thoughtspotitem.edit || {};
abcsetup.thoughtspotitem.edit.items = abcsetup.thoughtspotitem.edit.items || [];



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspotitem.edit = {
    init: function() {
        let copyData = {
            buyout: null,
            buyout_days: null,
            dating_terms: null,
            billback_perc: null,
            ship_period_from: null,
            ship_period_to: null,
            kaiser: null,
            kaiser_contract: null,
            humana: null,
            ecommerce: null,
            nations: null
        };

        abcsetup.setTitle('Submit Annual Buying Event Items.');
        abcsetup.event = JSON.parse($('#item_object').text());

        $(document).on('click', '#add-btn', function() {
            abcsetup.thoughtspotitem.edit.addItem();
        });

        $(document).on('click', '.btn.btn-link', function (e) {
            abcsetup.thoughtspotitem.edit.appendItem($(this).data('id'));

            $('#in_event_'+$(this).data('id')).attr('style', 'color:green;').text('Yes'); //mark as in event
            $(this).attr('disabled', true); //disabled button
            $(this).attr('title', "This item has already been added!");

        });

        $(document).on('click', '.btn.btn-remove-item', function (e) {
            let eventId = $('#event_id').val();
            let itemId = $(this).data('item_id')

            if (eventId == null || itemId == null) {
                abcsetup.alerts.show('Something went wrong.', `Something went wrong removing this item. Try refreshing your browser.`);
            }

            abcsetup.alerts.confirm('Remove Item', 'Are you sure you want to remove this item?', async function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);

                    try {
                        const formData = new FormData(document.getElementById('ts-items-form'));
                        const parsedData = abcsetup.thoughtspotitem.edit.parseNestedData(formData);
                        let saved = false;
            
                        if (Number($('#event-item-count').val()) > 0 && !saved) {
                            await abcsetup.thoughtspotitem.edit.autoSaveItems(parsedData, eventId);
                            saved = true;
                        } else {
                            saved = true;
                        }
            
                        if (saved) {
                            await abcsetup.thoughtspotitem.edit.removeItem(parsedData, eventId, itemId);
                        }

                        window.LaravelDataTables['app_data_tables_thought_spot_items_form_data_table'].ajax.reload();
                    } catch (error) {
                        console.error("Error processing item:", error);
                    } finally {
                        abcsetup.unblockUI();
                    }
                }
            });
        });

        $(document).on('click', "#submit-confirm-btn", function(e) {
            fieldValidate.runValidations($('input.item_field'));
            fieldValidate.runValidations($('select.item_field'));

            if ($('#price_change_before_end_of_thoughtspot').val() == '') {
                e.preventDefault();
                return abcsetup.alerts.show(`Field Not Complete`, `Please selected Yes/No for the "Do you anticipate a price change between now and the end of ThoughtSpot?" field.`); 
            }

            e.preventDefault();

            abcsetup.alerts.confirm(
                'Submit items for review?',
                `Are you sure you are ready to submit these item(s) for review?`,
                function(resp) {
                    if (resp) {
                        $('#submitBtn').click();
                    }
            });
        });

        //copy & paste
        $(document).on('click', '.btn-copy-item', function(e) {
            let _this = $(this);

            Object.entries(copyData).forEach(([key, value]) => {
                copyData[key] = _this.closest('tr.item_row').find(`.${key}`).first().val();
            });

            $('#paste_to_all_btn').attr('disabled', false);
            $('#clear_copy_paste_btn').attr('disabled', false);
            $('.btn-paste-item').attr('disabled', false);
        });

        $(document).on('click', '#paste_to_all_btn', function(e) {
            let _this = $(this);

            Object.entries(copyData).forEach(([key, value]) => {
                $(`.${key}[data-status="vendor_in_process"]`).val(value);

                if (key == 'kaiser' && value == 1) {
                    $(_this).closest('tr').find('.kaiser_contract').attr('disabled', false);
                }
            });
        });

        $(document).on('click', '.btn-paste-item', function(e) {
            let _this = $(this);

            Object.entries(copyData).forEach(([key, value]) => {
               $(_this).closest('tr').find(`.${key}[data-status="vendor_in_process"]`).val(value);

                if (key == 'kaiser' && value == 1) {
                    $(_this).closest('tr').find('.kaiser_contract').attr('disabled', false);
                }
            });
        });

        $(document).on('click', '#clear_copy_paste_btn', function(e) {
            Object.entries(copyData).forEach(([key]) => {
                copyData[key] = null;
            });

            $('.btn-paste-item').attr('disabled', true);
            $('#paste_to_all_btn').attr('disabled', true);
            $(this).attr('disabled', true);
        });

        $(document).on('click', '.inactive-item-btn-hider', function(e) {
            if ($(this).attr('data-enabled') == "true") {
                $('tr.inactive').removeClass('d-none');
                $(this).attr('data-enabled', "false");
                $(this).text("Display Active Items Only");
            } else {
                $('tr.inactive').addClass('d-none');
                $(this).attr('data-enabled', "true");
                $(this).text("Display All Items");
            }
        });

        /* If buyout is N - days is not required - ABCS-3871 */
        $(document).on('change', '.buyout', function(e) {
            let buyout = $(this);
            let buyout_days = $(this).closest('tr').find('.buyout_days');

            if (buyout.val() == 'N') {
                buyout_days.removeAttr('required'); //set required false
                buyout_days.val("0"); // set val null
                buyout_days.removeClass('invalid'); //remove invalid class from classlist
                buyout_days.parent().find('small').remove(); //remove error if present
            } else if(buyout.val() == 'Y') {
                buyout_days.attr('required', true);
                buyout_days.val("90");
            } else {
                buyout_days.removeAttr('required');
            }
        });

        $(document).on('input', '.kaiser', function(e) {
            let value = $(this).val();
        
            if (value === "1") {
                $(this).closest('tr').find('.kaiser_contract').attr('disabled', false);
            } 
            
            if (value === "0" || value === "" || value === null) {
                $(this).closest('tr').find('.kaiser_contract').attr('disabled', true);
                $(this).closest('tr').find('.kaiser_contract').val(0);
            }
        });        

        //handle radio buttons
        this.handleRadioButtons();     
    },
    
    /**
     * Show the add item modal
     */
    addItem: function() {
        $('#item-modal .modal-title').html('Search and Add Items to Event');
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').find('#results').data('searchString', '').html('');
        $('#item-modal').modal('show');
        $('#item-modal .btn-column-search').attr('data-backdrop', false); //fixes search modal in yajra table
    },

    appendItem: async function(id) {
        let eventId = $('#event_id').val();
        let itemId = id;
    
        abcsetup.blockUI(true);
    
        try {
            const formData = new FormData(document.getElementById('ts-items-form'));
            const parsedData = abcsetup.thoughtspotitem.edit.parseNestedData(formData);
            let saved = false;

            if (Number($('#event-item-count').val()) > 0 && !saved) {
                await abcsetup.thoughtspotitem.edit.autoSaveItems(parsedData, eventId);
                saved = true;
            } else {
                saved = true;
            }

            if (saved) {
                await abcsetup.thoughtspotitem.edit.storeNewItem(eventId, itemId);
            }
    
            window.LaravelDataTables['app_data_tables_thought_spot_items_form_data_table'].ajax.reload();
        } catch (error) {
            console.error("Error processing item:", error);
        } finally {
            abcsetup.unblockUI();
        }
    },

    removeItem: async function(payload, event_id, item_id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/thoughtspotitem/delete?event_id=${event_id}&item=${item_id}`, {
                ...payload
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error(error);
                reject(error);
            });
        });
    },

    autoSaveItems: function(payload, eventId) {
        return new Promise((resolve, reject) => {
            axios.put(`/thoughtspotitem/${eventId}`, { 
                ...payload,
                autosave: true,
                form_action: 'update'
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error(error);
                reject(error);
            });
        });
    },

    storeNewItem: function(eventId, itemid) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/thoughtspotitem/store?event_id=${eventId}&item=${itemid}`)
                .then(response => {
                    if ($('.no_items_message').length) {
                        $('.no_items_message').fadeOut();
                    }

                    resolve(response.data);
                })
                .catch(error => {
                    abcsetup.unblockUI();
                    console.error(error);
                    reject(error);
                });
        })
    },

    handleRadioButtons: function() {
        $('#request_changes_submit_button').attr('disabled', true);

        $(document).on('click', '.request-item-changes', function(e) {
            if ($(this).val() == 'no_action') {
                $(this).parent().parent().parent()
                    .find('.buyout-change-request')
                    .attr('disabled', true)
                    .attr('required', false);

                $(this).parent().parent().parent()
                    .find('.dating-terms-change-request')
                    .attr('disabled', true)
                    .attr('required', false);

                $(this).parent().parent().parent()
                    .find('.discount-change-request')
                    .attr('disabled', true)
                    .attr('required', false);
            }

            if ($(this).val() == 'update') {
                $(this).parent().parent().parent()
                    .find('.buyout-change-request')
                    .attr('disabled', false)
                    .attr('required', true);

                $(this).parent().parent().parent()
                    .find('.dating-terms-change-request')
                    .attr('disabled', false)
                    .attr('required', true);

                $(this).parent().parent().parent()
                    .find('.discount-change-request')
                    .attr('disabled', false)
                    .attr('required', true);
            }
        });

        $(document).on('click', '.form-check-input, #item_changes_button', function(e) {
            let count = 0;

            $('.form-check-input').each(function() {
                if ($(this).is(':checked') && $(this).val() != 'no_action') {
                    count++;
                }
            });

            if (count > 0) {
                $('#request_changes_submit_button').attr('disabled', false);
            } else {
                $('#request_changes_submit_button').attr('disabled', true);
            }
        });
    },

    parseNestedData: function(formData) {
        const result = {};
    
        formData.forEach((value, key) => {
            const keys = key.split('[').map(k => k.replace(']', ''));
            keys.reduce((acc, part, index) => {
                if (index === keys.length - 1) {
                    acc[part] = value;
                } else {
                    acc[part] = acc[part] || {};
                }
                return acc[part];
            }, result);
        });
    
        return result;
    },

    fieldError: function() {
        abcsetup.unblockUI();
        //abcsetup.alerts.show('Error', 'There was a problem submitting your form. Please try again later.');
    },
}
